// src/icons/index.tsx
import React from 'react';
import { ReactComponent as ArrowDown } from './arrow_down.svg';
import { ReactComponent as DefaultMy } from './defult_my.svg';
import { ReactComponent as Menu } from './menu_hamburger.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as Listen } from './listen.svg';
import { ReactComponent as Mic } from './mic.svg';
import { ReactComponent as Stop } from './stop.svg';
import { ReactComponent as Refresh } from './refresh.svg';
import { ReactComponent as Play } from './play.svg';
import { ReactComponent as Pause } from './pause.svg';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Circle } from './circle.svg';
import { ReactComponent as PencilCheck } from './pensil_check.svg';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as Book } from './book.svg';
import { ReactComponent as BookA } from './book_a.svg';
import { ReactComponent as Word } from './word.svg';
import { ReactComponent as Block } from './block.svg';
import { ReactComponent as Textbook } from './book_a.svg';
import { ReactComponent as Ticket } from './ticket.svg';
import { ReactComponent as Person } from './person.svg';
import { ReactComponent as Enter } from './enter.svg';
import { ReactComponent as Download } from './download.svg';
import { ReactComponent as Image } from './image.svg';
import { ReactComponent as Money } from './money.svg';
import { ReactComponent as Plus } from './plus.svg';

// 아이콘 맵: key로 이름(name), value로 ReactComponent
export const ReactIcons: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  arrowDown: ArrowDown,
  defaultMy: DefaultMy,
  menu: Menu,
  search: Search,
  listen: Listen,
  mic: Mic,
  stop: Stop,
  refresh: Refresh,
  play: Play,
  pause: Pause,
  check: Check,
  close: Close,
  circle: Circle,
  pencilCheck: PencilCheck,
  info: Info,
  book: Book,
  bookA: BookA,
  word: Word,
  textbook: Textbook,
  ticket: Ticket,
  person: Person,
  enter: Enter,
  block: Block,
  download: Download,
  image: Image,
  money: Money,
  plus: Plus,
};

/** 범용 아이콘 컴포넌트 */
export interface IconProps {
  /** ReactIcons 키 (arrowDown, defaultMy, ...) */
  name: string;
  /** 크기(px) */
  size?: number | string; 
  /** fill 색상 */
  color?: string;
  /** 추가 스타일 */
  style?: React.CSSProperties;
  [key: string]: any;
}

export const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  style = {},
  ...rest
}) => {
  const Svg = ReactIcons[name];
  if (!Svg) {
    console.warn(`Icon: "${name}" 아이콘이 없습니다.`);
    return null;
  }
  return (
    <Svg
      width={size}
      height={size}
      fill={color}
      style={{ verticalAlign: 'middle', ...style }}
      {...rest}
    />
  );
};